import { EMapSelectionActionType } from './types';
import { IMapSelection, TMapSelection } from '../../../Map/types/mapSelection';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setMapSelection = actionGenerator<EMapSelectionActionType.Changed, TMapSelection>(
  EMapSelectionActionType.Changed,
);

export const updateMapSelectionFeature = actionGenerator<EMapSelectionActionType.FeatureUpdated, IMapSelection>(
  EMapSelectionActionType.FeatureUpdated,
);
